import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import HomeBanner from '../../../components/HomeBanner'
import useIntervalFn from '../../../components/Slider/context/hooks/useIntervalFn'
import { loadSlider, nextSlide, previousSlide, goToSlide, transitionEnd } from './actions'
import { DURATION } from './constants'
import { makeSelectHomeSlider } from './selectors'
import { Slider } from './types'

export default function HomeBannerBox() {
  const dispatch = useDispatch()
  const slider = useSelector(makeSelectHomeSlider())?.toJS() as Slider
  const next = () => dispatch(nextSlide())
  const { start, clear } = useIntervalFn({ fn: () => next(), duration: DURATION })
  const load = (action: string) => dispatch(loadSlider(action))
  const previous = () => dispatch(previousSlide())
  const onTransitionEnd = () => dispatch(transitionEnd())

  useEffect(() => {
    if (!slider.loaded) {
      load('mainpage')
    }
  }, [])

  const goTo = (slide: number) => {
    start()
    dispatch(goToSlide(slide))
  }

  const handleArrowClick = (moveTo: string) => {
    start()

    if (moveTo === 'next') {
      next()
    } else {
      previous()
    }
  }

  return (
    <HomeBanner
      slider={slider}
      duration={DURATION}
      arrowClickHandler={handleArrowClick}
      goToSlide={goTo}
      onTransitionEnd={onTransitionEnd}
      clear={clear}
      start={start}
    />
  )
}
